/**
 * Created by nijin on 8/2/17.
 */
import { Injectable } from '@angular/core';
import {Http, XHRBackend, RequestOptions, Response, Headers, Request, RequestOptionsArgs} from "@angular/http";
import {Observable} from "rxjs";
import {AuthService} from "./auth.service";
import {UtilService} from "./util.service";

@Injectable()
export class HttpService extends Http{

  constructor( backend: XHRBackend,
               requestOptions: RequestOptions,
               private auth: AuthService,
               private util: UtilService) {

    super(backend, requestOptions);
  }

  buildPath(url: string, args: any): string {
    let actualUrl: string = url;
    Object.keys(args).forEach((key) => {
      if (args[key]) {
        actualUrl = actualUrl.replace(`:${key}`, args[key]);
      }
    });

    return actualUrl;
  }
  request(url: string|Request, options?: RequestOptionsArgs): Observable<Response> {
    let token = this.auth.getToken();
    if (typeof url === 'string') {
      if (!options) {
        options = {headers: new Headers()};
      }
      options.headers.set('Authorization', `Bearer ${token}`);
      options.headers.set('Content-Type', 'Application/json');
    } else {
      url.headers.set('Authorization', `Bearer ${token}`);
      url.headers.set('Content-Type', 'Application/json');
    }
    return super.request(url, options).catch(this.catchError);
  }

  private catchError = (res: Response) => {
    let body, message;
    switch (res.status) {
      case 401:
        this.auth.logout();
        break;
      case 0 :
        this.auth.navigateToServerDownPage();
        message = this.util.isOnline() ?
          'ERROR_MESSAGES.SERVER_NOT_AVAILABLE' : 'ERROR_MESSAGES.PLEASE_CHECK_NETWORK'
        return Observable.throw({
          message: message });
      case 404:
        body = {status: {message: 'ERROR_MESSAGES.RESOURCE_NOT_AVAILABLE'}};
        res['_body']  = JSON.stringify(body);
        break;
      case 500:
        body = {status: {message: 'ERROR_MESSAGES.INTERNAL_SERVER'}};
        res['_body']  = JSON.stringify(body);
        break;
        }
    return Observable.throw(res);
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/http.client.service.ts